import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    active: Boolean,
    interval: { type: Number, default: 3000 },
    url: String,
  }

  connect() {
    if (this.activeValue) this.scheduleRefresh()
  }

  disconnect() {
    window.clearTimeout(this.timer)
    this.abortController?.abort()
  }

  scheduleRefresh() {
    this.timer = window.setTimeout(() => this.refresh(), this.intervalValue)
  }

  async refresh() {
    this.abortController = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        credentials: "same-origin",
        headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
        signal: this.abortController.signal,
      })
      if (!response.ok) throw new Error(`Progress request failed with ${response.status}`)

      this.element.outerHTML = await response.text()
    } catch (error) {
      if (error.name !== "AbortError") this.scheduleRefresh()
    }
  }
}
